import React from 'react';
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import searchIcon from "../../assets/images/search-normal.svg";
import CustomTable from "../customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import {useEffect, useState} from "react";
import GroupInstallmentPayment from "../GroupInstallmentPayment/GroupInstallmentPayment";
import GroupPayment from "../GroupPayment/GroupPayment";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {InstallmentsService} from "./InstallmentsService";
import {CashGroupService} from "../../pages/CashGroups/CashGroupService";
import {convertCurrencyFormat, convertToBirthDate} from "../../utils/numberConvertor";
import moment from "jalali-moment";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import filterPaid from "../../assets/images/svg/document-filter.svg"
import {css} from "@emotion/css";
import DefaultDialogPage, {DialogSize} from "../defaultDialogPage/DefaultDialogPage";

let selectedItemId = -1
const Installments = () => {

    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new InstallmentsService(fundID, token, snackbar, loading)
    const serviceGroup = new CashGroupService(fundID, token, snackbar, loading)


    const [needRefresh, setNeedRefresh] = useState(false);

    const [groupsList, setGroupsList] = useState([]);
    const [itemCount, setItemCount] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    // Dialog-start
    const [openDialog, setOpenDialog] = useState(false)
    const handleClose = () => {
        setOpenDialog(false);
    };
    const handleClickOpen = () => {
        setOpenDialog(true);
    };
    // Dialog-end
    //modal-start
    const [openModal, setOpenModal] = useState(false)
    const handleClickOpenModal = () => {
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setOpenModal(false)
        if (needRefresh) {
            setNeedRefresh(false)
            getListDataFromServer()
        }
    }
    //modal-end


    const showEventsContent = (rowId) => {
        selectedItemId = rowId
        // setOpenDialog(true);
    }

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getListDataFromServer()
            getGroupListFromServer()
        }
    }, [])

    const [filterText, setFilterText] = useState("");
    const [filterSelectedValue, setFilterSelectedValue] = useState("group-name");

    function prepareFilter(filter, type) {
        return type === "groupCode" ? {
            "groupCode": filter
        } : type === "group-name" ? {
            "group-name": filter
        } : type === "deposit-account-number" ? {
            "deposit-account-number": filter
        } : ""
    }

    function getListDataFromServer(filter = filterText, filterSelect = filterSelectedValue) {
        loading(setLoadingStateDispatch(true))
        service.getInstallmentsList(fundID, page, prepareFilter(filter, filterSelect), paymentStatus.type,endDate)
            .then(response => {
                setInstallmentsListData(response)
                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت اطلاعات اقساط", snackbar, loading)
        })
    }

    const [installmentsList, setInstallmentsList] = useState([]);

    function prepareTableJsonList(
        id, number, firstName, lastName, nationalCode,
        groupName, numberOfInstallment, amountPayable,
        dateOfPayment, paidAt, amountPaid, paid, remindAmountOfLoan, remindAmountOfInstallment, status, paidByManger, paidByMember) {

        return {
            id: id,
            number: number,
            installmentID: id,
            fullName: `${firstName} ${lastName}`,
            nationalCode: nationalCode,
            phoneNumber: "09139634595",
            group: groupName ? groupName : "-",
            amount: convertCurrencyFormat(amountPayable),
            amountPaid: convertCurrencyFormat(amountPaid),
            remindAmountOfInstallment: convertCurrencyFormat(remindAmountOfInstallment),
            remindAmountOfLoan: remindAmountOfLoan ? convertCurrencyFormat(remindAmountOfLoan) : "0",
            paid: paid ?
                <span
                    className="cardCustomDescription bg_active_state d-flex flex-shrink-1">پرداخت شده</span>
                : <span
                    className="cardCustomDescription bg_deActive_state d-flex flex-shrink-1">پرداخت نشده</span>,
            DueDate: moment(dateOfPayment, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD'),
            paidAt: paidAt ? moment(paidAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "-",
            paidBy: paidByManger ? paidByManger : paidByMember ? paidByMember : "-"
        }
    }

    function setInstallmentsListData(installments) {
        setItemCount(installments.numberOfItems)
        setPageCount(installments.totalPage)
        setInstallmentsList([])

        installments.data.map((item, index) => {
            console.log("سیسیسی",
                item.remindAmountOfInstallment)
            setInstallmentsList((prevState => [...prevState,
                prepareTableJsonList(
                    item.id,
                    (page * 20) + index + 1,
                    item.firstName,
                    item.lastName,
                    item.nationalCode,
                    item.groupName,
                    item.numberOfInstallment,
                    item.amountPayable,
                    item.dateOfPayment,
                    item.paidAt,
                    item.amountPaid,
                    item.paid,
                    item.remindAmountOfLoan,
                    item.remindAmountOfInstallment,
                    item.status,
                    item.paidByManger,
                    item.paidByMember,
                )
            ]))
        })
    }


    function getGroupListFromServer() {
        serviceGroup.getCashGroupsList(fundID, 0, "", "", 1000)
            .then(response => {
                setGroupsList(response.data)
            }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت لیست گروه ها"))
        })
    }

    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };
    // filter-dialog-start
    const [openFilterDialog, setOpenFilterDialog] = useState(false)
    const [paymentStatus, setPaymentStatus] = useState(paidStatusTypes.ALL)

    const [endDate, setEndDate] = useState("");

    function doPaidStatusFilter() {
        if (endDate.length === 0 || endDate.length === 10) {
            page = 0;
            getListDataFromServer()
            setOpenFilterDialog(false)
        } else {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "تاریخ وارد شده صحیح نمی باشد."))
        }
    }

    // filter-dialog-end
    return (
        <>
            {
                <GroupInstallmentPayment
                    openDialog={openDialog}
                    handleClose={handleClose}
                    handleClickOpen={handleClickOpen}
                />
            }
            {
                <GroupPayment
                    openModal={openModal}
                    handleCloseModal={handleCloseModal}
                    needRefresh={setNeedRefresh}
                    groupsInfo={groupsList}
                />
            }
            {
                <DefaultDialogPage
                    pageTitle={"فیلتر ها"}
                    dialogSize={DialogSize.WRAP_CONTENT}
                    open={openFilterDialog}
                    onClose={_ => {
                        setOpenFilterDialog(false)
                    }}>
                    <section className={css`
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                      gap: .5rem;
                      padding: 1rem`}>
                        <FormControl variant="outlined" className="w-100" style={{flexGrow: "1"}}>
                            <InputLabel htmlFor="filled-age-native-simple">فیلتر بر اساس وضعیت پرداخت</InputLabel>
                            <Select label="فیلتر بر اساس وضعیت پرداخت"
                                    value={paymentStatus.id}
                                    onChange={e => {
                                        switch (e.target.value) {
                                            case paidStatusTypes.ALL.id:
                                                setPaymentStatus(paidStatusTypes.ALL)
                                                break;
                                            case paidStatusTypes.PAID.id:
                                                setPaymentStatus(paidStatusTypes.PAID)
                                                break;
                                            case paidStatusTypes.UN_PAID.id:
                                                setPaymentStatus(paidStatusTypes.UN_PAID)
                                                break;
                                        }
                                    }}>
                                <option value={paidStatusTypes.ALL.id}>{paidStatusTypes.ALL.title}</option>
                                <option value={paidStatusTypes.PAID.id}>{paidStatusTypes.PAID.title}</option>
                                <option value={paidStatusTypes.UN_PAID.id}>{paidStatusTypes.UN_PAID.title}</option>
                            </Select>
                        </FormControl>
                        <TextField className='w-100' variant="outlined" label="تا تاریخ"
                                   value={convertToBirthDate(endDate)}
                                   onChange={e => {
                                       setEndDate(convertToBirthDate(e.target.value))
                                   }}/>
                        <Button
                            className={`btn-confirm ${css`align-self: end`}`}
                            onClick={doPaidStatusFilter}>
                            اعمال
                            فیلتر</Button>
                    </section>
                </DefaultDialogPage>
            }

            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className={`d-flex flex-column flex-nowrap flex-grow-1 ${css`align-items: start`}`}>
                        <Typography variant={"h5"}>
                            لیست اقساط
                        </Typography>
                        {itemCount > 0 &&
                            <Typography
                                className={css`margin: 8px 0;
                                  width: 100%;`} variant={"caption"}>
                                {" " + itemCount + " قسط ثبت شده "}
                            </Typography>}
                    </section>
                    <Button
                        variant='contained'
                        onClick={handleClickOpenModal}
                        // onClick={() => {
                        //     selectedItemId = -1
                        //     setOpenDialog(true);
                        // }}
                        // startIcon={<DeleteIcon/>}
                    >
                        پرداخت گروهی اقساط
                    </Button>
                </Box>
                <Box className="w-100" sm={12}>

                </Box>
                <Grid className="d-flex flex-row flex-wrap w-100" sm={12}>
                    <Grid sm={12} md={8} lg={8} xl={8} className='modalTextFieldContainer'>
                        <TextField
                            value={filterText}
                            onChange={e => {
                                setFilterText(e.target.value)
                                getListDataFromServer(e.target.value)
                            }}
                            className='w-100'
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="جستجو"
                            placeholder="عبارت مورد نظر را وارد نمایید..."/>
                    </Grid>
                    <Grid xs={12} sm={12} md={4} lg={4} xl={4}
                          className="d-flex flex-row flex-nowrap alignItemsCenter w-100"
                          style={{gap: "8px"}}>
                        <FormControl variant="outlined" className="w-100" style={{flexGrow: "1"}}>
                            <InputLabel htmlFor="filled-age-native-simple">جستجو بر اساس</InputLabel>
                            <Select label="جستجو بر اساس"
                                    value={filterSelectedValue}
                                    onChange={e => {
                                        setFilterSelectedValue(e.target.value)
                                        getListDataFromServer(filterText, e.target.value)
                                    }}>
                                <option value={"group-name"}>نام گروه</option>
                                <option value={"groupCode"}>کد گروه</option>
                                <option value={"deposit-account-number"}>شماره حساب</option>
                            </Select>
                        </FormControl>
                        <section className={css`
                          background: #EBECF1 !important;
                          border-radius: 10px !important;
                          padding: 0.75rem 1rem;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          cursor: pointer;
                        `}
                                 onClick={_ => {
                                     setOpenFilterDialog(true)
                                 }}
                        >
                            <img src={filterPaid} alt="filterPaid"/>
                        </section>
                    </Grid>

                </Grid>


                <CustomTable
                    header={columns}
                    data={installmentsList}
                    rowClicked={showEventsContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>

        </>

    )
}
export default Installments;


const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'installmentID',
        label: 'شناسه قسط',
        align: 'right',
    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',
        align: 'right',
    },
    {
        id: 'nationalCode',
        label: 'کد ملی',
        align: 'right',
    },
    {
        id: 'group',
        label: 'گروه',
        align: 'right',
    },
    {
        id: 'amount',
        label: 'مبلغ (ریال)',
        align: 'right',
    },
    {
        id: 'amountPaid',
        label: 'پرداخت شده (ریال)',
        align: 'right',
    },
    {
        id: 'remindAmountOfLoan',
        label: 'باقی مانده وام (ریال)',
        align: 'right',
    },
    {
        id: 'DueDate',
        label: 'سررسید',
        align: 'right',
    },
    {
        id: 'remindAmountOfInstallment',
        label: 'باقی مانده قسط',
        align: 'right',
    },
    {
        id: 'paidAt',
        label: 'تاریخ پرداخت',
        align: 'right',
    },
    {
        id: 'paidBy',
        label: 'پرداخت کننده',
        align: 'right',
    },
    {
        id: 'paid',
        label: 'وضعیت',
        align: 'right',
    },
];
const paidStatusTypes = {
    ALL: {
        id: "ALL",
        type: "",
        title: "همه"
    },
    PAID: {
        id: "PAID",
        type: "PAID",
        title: "پرداخت شده"
    },
    UN_PAID: {
        id: "UN_PAID",
        type: "UN_PAID",
        title: "پرداخت نشده"
    },
}